// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "9c4fc1b35159928e5301fee6f6d382ff76b4d3d9/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};